
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';

/**
 * The customer's own address as held on the job (`Job.customerSite`), separate from the job's own
 * site (`jobSite`) and from the customer record's primary site (`jobCustomer.*`, a live CRM read).
 *
 * Address fields only. `SiteTiny` also carries flat `contact*` fields, but the customer's contact
 * lives in `Job.supervisor` and is published as its own group — exposing empty `contact*` tokens
 * here would give template authors a second, always-blank answer to the same question.
 */
@MergeSchema({
    entity: ActivityEntityName.Site
})
export class JobCustomerAddressMergeData {

    @MergeField()
    street: string;

    @MergeField()
    suburb: string;

    @MergeField()
    state: string;

    @MergeField()
    postcode: string;

    @MergeField()
    fullAddress: string;

    @MergeField()
    name: string;

    @MergeField()
    country: string;

    @MergeField()
    county: string;

    @MergeField()
    postalCode: string;

    @MergeField()
    placeId: string;

    siteId: string;
}

export const JobCustomerAddressMergeSchema = getSchema(JobCustomerAddressMergeData);
